<template>
    <v-container
        fluid
        class="fill-height"
    >
        <v-card
            v-if="!requestSuccess"
            max-width="500"
            class="mx-auto"
            elevation="0"
        >
            <div class="d-flex justify-center mb-5">
                <img src="../assets/forgot-password.png">
            </div>
            <v-card-title class="d-flex justify-center mb-5">
                Forgot Password
            </v-card-title>
            <v-card-subtitle class="d-flex text-center justify-center">
                Enter your Email or Username below to request a password reset.
            </v-card-subtitle>
            <v-card-text class="my-3 pb-0">
                <v-form
                    ref="form"
                    v-model="valid"
                >
                    <div class="py-2">
                        <v-alert
                            v-if="showError"
                            text
                            dark
                            type="error"
                            dismissible
                        >
                            {{ errorMessage }}
                        </v-alert>
                    </div>
                    <v-text-field
                        v-model="username"
                        :rules="usernameRules"
                        outlined
                        label="Email or Username"
                        required
                    />
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-row class="px-5">
                    <v-btn
                        :disabled="!valid"
                        color="primary"
                        block
                        large
                        class="mx-auto mb-6"
                        @click="submit()"
                    >
                        Submit Request
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        large
                        class="mx-auto"
                    >
                        <router-link
                            to="/signin"
                        >
                            Back
                        </router-link>
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card
            v-else
            class="mx-auto"
            elevation="0"
        >
            <div class="d-flex justify-center mb-5">
                <img src="../assets/pw-changed.png">
            </div>
            <v-card-title class="d-flex justify-center mb-5">
                Request Sent Successfully
            </v-card-title>
            <v-card-subtitle class="d-flex text-center justify-center">
                Thank you for submitting your request. You will receive an email with a password reset link.
            </v-card-subtitle>
            <v-card-actions>
                <v-row class="px-5">
                    <v-btn
                        color="primary"
                        outlined
                        large
                        class="mx-auto"
                    >
                        <router-link
                            to="/signin"
                        >
                            Back to Sign-in
                        </router-link>
                    </v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-container>
</template>
<script>
import webtmsBackend from '../services/webtmsBackend';

export default {
    data: () => ({
        valid: true,
        requestSuccess: false,
        errorMessage: '',
        username: '',
        usernameRules: [
            v => !!v || 'Username or E-mail is required',
        ],
    }),
    computed: {
        showError: function () {
            return this.errorMessage.length > 0;
        },
    },
    methods: {
        validate() {
            this.$refs.form.validate();
        },
        async submit() {
            try {
                this.errorMessage = '';
                const response = await webtmsBackend.requestResetEmail(this.username);
                if(response.success) {
                    this.requestSuccess = true;
                } else {
                    this.errorMessage = response.err;
                    this.requestSuccess = false;
                }
            } catch (error) {
                this.errorMessage = error.message;
                this.requestSuccess = false;
            }
        }
    }
};
</script>
<style scoped>
a {
    text-decoration: none;
}
</style>